module.exports = __webpack_public_path__ + "img/Women-Signing-Deal.cc403167.png";